import {LandingPage} from "./LandingPage";

export const LandingPageWrapper = ({loading}) => (
    <>
        <LandingPage loading={loading}/>
    </>
);